var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMlpPool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.398438,
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_4255_14289)",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4255_14289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.3633,
    y: 27.8076,
    width: 3,
    height: 7.1349,
    transform: "rotate(-30 32.3633 27.8076)",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7.85832,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 28.2812 27.3767)",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 6,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 33.3984 39)",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3984 25.2857V18.2143L30.3984 15L36.3984 18.2143V25.2857L30.3984 28.5L24.3984 25.2857Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3984 41.7857V34.7143L39.3984 31.5L45.3984 34.7143V41.7857L39.3984 45L33.3984 41.7857Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3984 41.7857V34.7143L21.3984 31.5L27.3984 34.7143V41.7857L21.3984 45L15.3984 41.7857Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4255_14289",
    x1: 9.39844,
    y1: 2,
    x2: 60.3984,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4255_14289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12.3984 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlpPool);
export default __webpack_public_path__ + "static/media/mlpPool.24a5f6f80953a19d97cabe2711f7ff7a.svg";
export { ForwardRef as ReactComponent };